import { useFormContext } from "react-hook-form";
import { useLingui } from "@lingui/react/macro";
import styles from "./CustomRecurringInput.module.scss";
import { Text } from "@medoma/components/Text/Text";
import { Plural, Trans } from "@lingui/react/macro";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import InputField from "@medoma/components/InputField/InputField";
import Select from "@medoma/components/Select/Select";
import {
  customRecurrenceIntervalUnitSchema,
  type ICustomRecurrenceInterval,
  type ICustomRecurrenceIntervalUnit,
} from "./schedulingModels";

export type ICustomRecurringIntervalFields = {
  customRecurrenceInterval: ICustomRecurrenceInterval | null;
  customRecurrenceIntervalUnit: ICustomRecurrenceIntervalUnit | null;
};

export const CustomRecurringInterval = () => {
  const {
    formState: { errors },
    register,
    watch,
  } = useFormContext<ICustomRecurringIntervalFields>();

  const { t } = useLingui();

  const interval = watch("customRecurrenceInterval");

  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.legend}>
        <Trans>Anpassad upprepning</Trans>
      </legend>
      {errors.customRecurrenceInterval?.message ? (
        <div className={styles.errorMessage}>
          <ErrorMessage
            message={errors.customRecurrenceInterval.message}
            weight="bold"
          />
        </div>
      ) : null}
      {errors.customRecurrenceIntervalUnit?.message ? (
        <div className={styles.errorMessage}>
          <ErrorMessage
            message={errors.customRecurrenceIntervalUnit.message}
            weight="bold"
          />
        </div>
      ) : null}
      <div className={styles.inputWrapper}>
        <Text element="div">
          <Trans
            context={
              "Prefix for custom recurrence interval, e.g. 'Var 3:e vecka' or 'Var 2:a dag'"
            }
          >
            Var
          </Trans>
        </Text>
        <InputField
          label={t`Upprepningsintervall`}
          hideLabel
          showOptionalLabel={false}
          type="number"
          outerWidth="fit"
          {...register("customRecurrenceInterval", {
            required: {
              value: true,
              message: t`Ange upprepningsintervall`,
            },
            min: {
              value: 1,
              message: t`Ange upprepningsintervall som minst 1`,
            },
          })}
        />
        <Select
          label={t`Enhet för upprepningsintervall`}
          hideLabel
          {...register("customRecurrenceIntervalUnit", {
            required: {
              value: true,
              message: t`Välj en enhet för upprepningsintervallet`,
            },
          })}
        >
          <option value={customRecurrenceIntervalUnitSchema.enum.weeks}>
            <Plural
              value={interval ? interval : "0"}
              _1="vecka"
              other="vecka"
            />
          </option>
          <option value={customRecurrenceIntervalUnitSchema.enum.days}>
            <Plural value={interval ? interval : "0"} _1="dag" other="dag" />
          </option>
        </Select>
      </div>
    </fieldset>
  );
};
